import React from 'react';
import propTypes from 'prop-types';

export const DebitCardIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 460 460"
      enableBackground="new 0 0 460 460"
      // style="enable-background:new 0 0 460 460;"
      xmlSpace="preserve"
    >
      <g id="XMLID_88_">
        <g>
          <g>
            <path
              d="M434.743,82.126H25.257C11.308,82.126,0,93.435,0,107.383v164.49h460v-164.49C460,93.435,448.692,82.126,434.743,82.126z
				 M158.102,197.837L158.102,197.837c-0.001,6.6-5.401,12-12.001,12H56.657c-6.6,0-12-5.4-12-12v-42.127c0-6.6,5.4-12,12-12h89.445
				c6.6,0,12,5.4,12,12V197.837z M313.511,216.495c-7.504,4.743-16.389,7.498-25.922,7.498c-26.842,0-48.601-21.76-48.601-48.601
				c0-26.842,21.759-48.601,48.601-48.601c10.126,0,19.527,3.1,27.311,8.398c-8.836,11.549-14.102,25.967-14.102,41.599
				C300.798,191.579,305.519,205.279,313.511,216.495z M369.399,225.389c-26.842,0-48.601-21.76-48.601-48.601
				s21.759-48.601,48.601-48.601c26.842,0,48.601,21.759,48.601,48.601C418,203.631,396.241,225.389,369.399,225.389z"
            />
            <path d="M0,352.616c0,13.949,11.308,25.257,25.257,25.257h409.486c13.949,0,25.257-11.308,25.257-25.257v-12.743H0V352.616z" />
          </g>
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
DebitCardIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
DebitCardIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
